import { Toaster } from "react-hot-toast";

const GlobalToaster = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        // Base styles (apply to all toasts)
        style: {
          background: "#FFFFFF",
          color: "#000750",
          borderRadius: "10px",
          padding: "12px 16px",
          fontFamily: "Poppins, sans-serif",
          boxShadow: "0 4px 14px rgba(0, 0, 0, 0.08)",
          border: "1px solid #E2E2E2",
        },

        //  Success Toast
        success: {
          iconTheme: {
            primary: "#0CC763",
            secondary: "#fff",
          },
          style: {
            borderLeft: "4px solid #0CC763",
          },
        },

        //  Error Toast
        error: {
          iconTheme: {
            primary: "#FF4523",
            secondary: "#fff",
          },
          style: {
            borderLeft: "4px solid #FF4523",
          },
        },

        //  Loading Toast
        loading: {
          iconTheme: {
            primary: "#735DFF",
            secondary: "#fff",
          },
          style: {
            borderLeft: "4px solid #735DFF",
          },
        },
      }}
    />
  );
};

export default GlobalToaster;
